(function () {
  window.Alloy = {
    openWorkflowModal: (
      token,
      workflowId,
      callback,
      { alwaysShowCredentials, allowInstantWorkflowCreation },
      title
    ) => {
      const body = document.querySelector('body');
      const modal = document.createElement('div');

      const modalMask = document.createElement('div');
      const closeModal = () => {
        body.removeChild(modal);
        if (callback) {
          callback();
        }
      };
      modalMask.style.position = 'fixed';
      modalMask.style.top = 0;
      modalMask.style.right = 0;
      modalMask.style.left = 0;
      modalMask.style.bottom = 0;
      modalMask.style.zIndex = 1000;
      modalMask.style.height = '100%';
      modalMask.style.backgroundColor = 'rgba(0,0,0,0.45)';
      modalMask.addEventListener('click', closeModal);
      if (allowInstantWorkflowCreation) modal.style.display = 'none';
      modal.appendChild(modalMask);

      const modalContainer = document.createElement('div');
      modalContainer.style.position = 'fixed';
      modalContainer.style.top = 0;
      modalContainer.style.right = 0;
      modalContainer.style.left = 0;
      modalContainer.style.bottom = 0;
      modalContainer.style.zIndex = 1000;
      modalContainer.style.height = '100%';
      modalContainer.addEventListener('click', closeModal);
      modal.appendChild(modalContainer);

      const modalBody = document.createElement('div');
      modalBody.style.width = '384px';
      modalBody.style.margin = '75px auto 75px auto';
      modalBody.style.height = '80vh';
      modalBody.style.maxHeight = '608px';
      modalBody.style.backgroundColor = '#fff';
      modalBody.style.borderRadius = '6px';

      modalContainer.appendChild(modalBody);

      const domain = 'https://app.runalloy.com';

      const path = 'forge-install';

      let workflowParameter = '';
      if (Array.isArray(workflowId)) {
        workflowId.forEach((id) => {
          workflowParameter += `id=${id}&`;
        });
      } else {
        workflowParameter = `id=${workflowId}&`;
      }

      let iFrameSrc = `${domain}/${path}?${workflowParameter}token=${token}&forgeMode=engaged`;

      if (allowInstantWorkflowCreation) {
        iFrameSrc += '&allowInstantWorkflowCreation=true';
      }
      if (alwaysShowCredentials) {
        iFrameSrc += '&alwaysShowCredentials=true';
      }

      if (title) {
        iFrameSrc += `&title=${title}`;
      }

      const iFrame = document.createElement('iframe');
      iFrame.src = iFrameSrc;

      iFrame.style.minWidth = '100%';
      iFrame.style.minHeight = '100%';
      iFrame.style.border = 'none';
      iFrame.style.borderRadius = '6px';

      modalBody.appendChild(iFrame);

      body.appendChild(modal);

      const handleMessage = (event) => {
        if (!event || event.origin !== domain) {
          return;
        }

        if (event.data && event.data.showModal) {
          modal.style.display = 'block';
        } else if (event.data && event.data.closeModal) {
          callback();
          try {
            if (modal) {
              body.removeChild(modal);
            }
          } catch (err) {
            console.log(err);
          }
          window.removeEventListener('message', handleMessage);
        } else if (event.data && event.data.workflowCreated) {
          let closeTimeout = 200;
          if (callback) {
            if (event.data.workflowId) {
              callback(event.data.workflowId);
              closeTimeout = 1000;
            } else {
              callback();
            }
          }

          setTimeout(() => {
            try {
              if (modal) {
                body.removeChild(modal);
              }
            } catch (err) {
              console.log(err);
            }
            window.removeEventListener('message', handleMessage);
          }, closeTimeout);
        }
      };
      window.addEventListener('message', handleMessage);
    },
  };
})();
